import {
    batteryImg,
    // carAccessoriesImg,
    carLampsImg,
    motorOilImg, sparkPlugsImg, transmissionOilImg, wipeBladesImg,
} from "../assets/images/images.ts";
import {CartProduct, Product,} from "../widgets/ProductCard/types/productCard.interface.ts";

export const products = [
    {productId: 1, img: batteryImg, name: 'Аккумуляторы', link: '/catalog?id=396&name=аккумулятор'},
    {productId: 2, img: motorOilImg, name: 'Моторные масла', link: '/catalog?id=2640&name=моторное масло'},
    {productId: 3, img: sparkPlugsImg, name: 'Свечи зажигания', link: '/catalog?id=1028&name=свеча зажигания'},
    {productId: 4, img: transmissionOilImg, name: 'Трансмиссионные масла', link: '/catalog?id=2640&name=масло трансмиссионное'},
    {productId: 5, img: carLampsImg, name: 'Автолампы', link: '/catalog?id=80&name=лампа'},
    {productId: 6, img: wipeBladesImg, name: 'Щетки стеклоочистителя', link: '/catalog?id=1927&name=щетка стеклоочистителя'},
    // {productId: 7, img: carAccessoriesImg, name: 'Автоаксессуары', link: '/catalog?name='},
] as Product[];

export const cartProducts = [
    {productId: 1, img: motorOilImg, name: 'Моторные масла', link: 'link', brand: 'Union JAPAN', price: 550, amount: 1, isAvailable: false},
    {productId: 2, img: motorOilImg, name: 'Фильтр масляный', link: 'link', brand: 'Sakura', price: 1200, amount: 2, isAvailable: true},
] as CartProduct[];
